export default {"src":"/assets/_next/static/media/it.581523fb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};